import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getInvoiceDetails, doInvoiceCreate, doInvoiceUpdate 
} from "../../../../redux/invoice/invoiceState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import { NumberFormatter } from "../../../../utils/index";
import CrudButtons from "components/button/crudbuttons";
import { MODULE_INVOICES } from "variables/constants";
import { DATE_FORMAT } from "variables/constants";

const InvoiceForm = ({getRecord, doCreate, doUpdate, recordData, requesting, errors, onCancel, submitLabel, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId ?? 0);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){

			const { inv_issue_date, inv_due_date, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	            inv_issue_date: inv_issue_date ? dayjs(inv_issue_date, DATE_FORMAT) : null,
			    inv_due_date: inv_due_date ? dayjs(inv_due_date, DATE_FORMAT) : null,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  			
			const { inv_issue_date, inv_due_date, ...forSubmitValues } = values;			  
			forSubmitValues.inv_issue_date = inv_issue_date ? inv_issue_date.format('YYYY-MM-DD') : null;
			forSubmitValues.inv_due_date = inv_due_date ? inv_due_date.format('YYYY-MM-DD') : null;									
			recordData.inv_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="inv_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
			    <FormItem
			        name="inv_account_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>			    
        		<div className="grid grid-cols-1 md:grid-cols-4 gap-2"> 
					<FormItem 
		            	name="inv_status_id"
		                label="Status"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="inv_status_id"
							className="input-field"
						    options={recordData?.statusList}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.inv_status_name}</label>
		                }
	            	</FormItem>
					<FormItem 
		            	name="inv_type_id"
		                label="Type"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="inv_type_id"
							className="input-field"
		            		options={recordData?.typeList}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.inv_type_name}</label>
		                }
	            	</FormItem>
					<FormItem extra="col-span-1 md:col-span-4"
		            	name="inv_client_id"
		                label="Client"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select 
							id="inv_client_id"
							className="input-field"
		            		options={recordData?.clientList}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.inv_client_name}</label>
		                }
	            	</FormItem>   
					<FormItem 
						label="Issue Date"
						name="inv_issue_date"
					>
						{mode !== "view" ?
						<DatePicker id="inv_issue_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.inv_issue_date}
						</label>
						}
					</FormItem>
					<FormItem 
						label="Due Date"
						name="inv_due_date"
					>
						{mode !== "view" ?
						<DatePicker id="inv_due_date"
							className="input-field"
							format={DATE_FORMAT}
							style={{ width: "100%" }}
						/>
						: 
						<label className="text-base label-value dark:text-white">
							{recordData?.inv_due_date}
						</label>
						}
					</FormItem>
	            	
	 			</div>		
				<CrudButtons baseRoute="/console/invoices" mode={mode} recordId={recordId} /> 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.invoice.invoiceDetails?.data,
  	requesting: state.invoice.invoiceDetails?.requesting,
  	errors: state.invoice.invoiceDetails?.errors,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getInvoiceDetails(id)),
  	doCreate: (data) => dispatch(doInvoiceCreate(data)),
  	doUpdate: (data) => dispatch(doInvoiceUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
